// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let QueryParamUtils = require("../../common/QueryParamUtils.bs.js");

function getDefaultState() {
  return {
    rentalMode: false,
    sortOrder: "RECENTLY_BROADCAST",
    includeNewDevelopments: false,
    active: true,
    withdrawnOrExpired: false,
    underContract: false,
    soldOrRented: false
  };
}

function clearDevelopmentFilters(p) {
  let newrecord = {...p};
  newrecord.includeNewDevelopments = false;
  return newrecord;
}

function normalizeDevelopmentParams(p) {
  if (p.rentalMode || !p.includeNewDevelopments) {
    return clearDevelopmentFilters(p);
  } else {
    return p;
  }
}

function toParams(p) {
  let defaultState = getDefaultState();
  let rentalMode = Stdlib_Option.getOr(p.rentalMode, defaultState.rentalMode);
  let active = Stdlib_Option.getOr(p.active, defaultState.active);
  let includeNewDevelopments = Stdlib_Option.getOr(p.includeNewDevelopments, defaultState.includeNewDevelopments);
  return normalizeDevelopmentParams({
    after: p.after,
    before: p.before,
    rentalMode: rentalMode,
    sortOrder: Stdlib_Option.getOr(p.sortOrder, defaultState.sortOrder),
    areaIds: p.areaIds,
    maxBeds: p.maxBeds,
    maxPrice: p.maxPrice,
    minBeds: p.minBeds,
    minPrice: p.minPrice,
    forSalePropertyTypes: p.forSalePropertyTypes,
    rentalPropertyTypes: p.rentalPropertyTypes,
    keywords: p.keywords,
    offMlsOnly: p.offMlsOnly,
    includeNewDevelopments: includeNewDevelopments,
    active: active,
    withdrawnOrExpired: Stdlib_Option.getOr(p.withdrawnOrExpired, defaultState.withdrawnOrExpired),
    underContract: Stdlib_Option.getOr(p.underContract, defaultState.underContract),
    soldOrRented: Stdlib_Option.getOr(p.soldOrRented, defaultState.soldOrRented)
  });
}

function fromUrl(params) {
  let rentalMode = QueryParamUtils.bool(params, "rentalMode");
  let sortOrder = Stdlib_Option.flatMap(QueryParamUtils.string(params, "sortOrder"), sortOrder => {
    switch (sortOrder) {
      case "RECENTLY_BROADCAST" :
        return "RECENTLY_BROADCAST";
      case "RECENTLY_UPDATED" :
        return "RECENTLY_UPDATED";
      default:
        return;
    }
  });
  let areaIds = QueryParamUtils.stringArrNonEmpty(params, "areaIds");
  let maxBeds = QueryParamUtils.int(params, "maxBeds");
  let minBeds = QueryParamUtils.int(params, "minBeds");
  let maxPrice = QueryParamUtils.int(params, "maxPrice");
  let minPrice = QueryParamUtils.int(params, "minPrice");
  let forSalePropertyTypes = Stdlib_Array.filterMap(params.getAll("forSalePropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "LOT" :
        return "LOT";
      case "MULTI_UNIT" :
        return "MULTI_UNIT";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let forSalePropertyTypes$1 = forSalePropertyTypes.length !== 0 ? forSalePropertyTypes : undefined;
  let rentalPropertyTypes = Stdlib_Array.filterMap(params.getAll("rentalPropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let rentalPropertyTypes$1 = rentalPropertyTypes.length !== 0 ? rentalPropertyTypes : undefined;
  let withdrawnOrExpired = QueryParamUtils.bool(params, "withdrawnOrExpired");
  let soldOrRented = QueryParamUtils.bool(params, "soldOrRented");
  let underContract = QueryParamUtils.bool(params, "underContract");
  let includeNewDevelopments = QueryParamUtils.bool(params, "includeNewDevelopments");
  let keywords = QueryParamUtils.stringArrNonEmpty(params, "keywords");
  let offMlsOnly = QueryParamUtils.bool(params, "offMlsOnly");
  let after = QueryParamUtils.string(params, "after");
  let before = Stdlib_Option.isNone(after) ? QueryParamUtils.string(params, "before") : undefined;
  let active = Stdlib_Option.getOr(QueryParamUtils.bool(params, "active"), true);
  return {
    before: before,
    after: after,
    rentalMode: rentalMode,
    sortOrder: sortOrder,
    areaIds: areaIds,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    forSalePropertyTypes: forSalePropertyTypes$1,
    rentalPropertyTypes: rentalPropertyTypes$1,
    keywords: keywords,
    offMlsOnly: offMlsOnly,
    includeNewDevelopments: includeNewDevelopments,
    active: active,
    soldOrRented: soldOrRented,
    withdrawnOrExpired: withdrawnOrExpired,
    underContract: underContract
  };
}

let ParamsFromURL = {
  toParams: toParams,
  fromUrl: fromUrl
};

function sortOrderForApi(useNewPropertiesUpdatedSort, sortOrder) {
  if (!useNewPropertiesUpdatedSort) {
    return sortOrder;
  }
  switch (sortOrder) {
    case "RECENTLY_UPDATED" :
      return "RECENTLY_UPDATED_EXCLUDING_RENEWALS";
    case "RECENTLY_BROADCAST" :
    case "RECENTLY_UPDATED_EXCLUDING_RENEWALS" :
      return sortOrder;
  }
}

function transformParamsForApi(useNewPropertiesUpdatedSortOpt, p) {
  let useNewPropertiesUpdatedSort = useNewPropertiesUpdatedSortOpt !== undefined ? useNewPropertiesUpdatedSortOpt : false;
  let p$1 = normalizeDevelopmentParams(p);
  let rentalStatuses = [];
  let forSaleStatuses = [];
  if (p$1.active !== false) {
    rentalStatuses.push("ACTIVE");
    forSaleStatuses.push("ACTIVE");
  }
  if (p$1.underContract) {
    forSaleStatuses.push("UNDER_CONTRACT");
  }
  if (p$1.withdrawnOrExpired) {
    forSaleStatuses.push("WITHDRAWN", "EXPIRED");
    rentalStatuses.push("WITHDRAWN", "EXPIRED");
  }
  if (p$1.soldOrRented) {
    forSaleStatuses.push("SOLD");
    rentalStatuses.push("RENTED");
  }
  let first = Stdlib_Option.isNone(p$1.before) ? 12 : undefined;
  let last = Stdlib_Option.isSome(p$1.before) ? 12 : undefined;
  return {
    rentalMode: p$1.rentalMode,
    after: p$1.after,
    before: p$1.before,
    sortOrder: sortOrderForApi(useNewPropertiesUpdatedSort, p$1.sortOrder),
    areaIds: p$1.areaIds,
    maxBeds: p$1.maxBeds,
    maxPrice: p$1.maxPrice,
    minBeds: p$1.minBeds,
    minPrice: p$1.minPrice,
    forSalePropertyTypes: p$1.forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    rentalPropertyTypes: p$1.rentalPropertyTypes,
    rentalStatuses: rentalStatuses,
    keywords: p$1.keywords,
    offMlsOnly: p$1.offMlsOnly,
    includeNewDevelopments: p$1.includeNewDevelopments,
    first: first,
    last: last
  };
}

let Params = {
  sortOrderForApi: sortOrderForApi,
  transformParamsForApi: transformParamsForApi
};

function toQueryString(params) {
  let params$1 = normalizeDevelopmentParams(params);
  let searchParams = new URLSearchParams("");
  let defaultState = getDefaultState();
  if (params$1.rentalMode) {
    QueryParamUtils.setIfExists(searchParams, "rentalMode", "true", s => s);
  }
  if (params$1.includeNewDevelopments) {
    QueryParamUtils.setIfExists(searchParams, "includeNewDevelopments", "true", s => s);
  }
  if (params$1.sortOrder !== defaultState.sortOrder) {
    QueryParamUtils.setIfExists(searchParams, "sortOrder", params$1.sortOrder, s => s);
  }
  QueryParamUtils.setIfExistsArrStr(searchParams, "areaIds", params$1.areaIds);
  QueryParamUtils.setIfExistsInt(searchParams, "minPrice", params$1.minPrice);
  QueryParamUtils.setIfExistsInt(searchParams, "maxPrice", params$1.maxPrice);
  QueryParamUtils.setIfExistsInt(searchParams, "minBeds", params$1.minBeds);
  QueryParamUtils.setIfExistsInt(searchParams, "maxBeds", params$1.maxBeds);
  QueryParamUtils.setIfExistsArr(searchParams, "forSalePropertyTypes", params$1.forSalePropertyTypes, v => v);
  QueryParamUtils.setIfExistsArr(searchParams, "rentalPropertyTypes", params$1.rentalPropertyTypes, v => v);
  QueryParamUtils.setIfExistsArrStr(searchParams, "keywords", params$1.keywords);
  let match = params$1.offMlsOnly;
  if (match !== undefined && match) {
    QueryParamUtils.setIfExists(searchParams, "offMlsOnly", "true", s => s);
  }
  QueryParamUtils.setIfExists(searchParams, "after", params$1.after, s => s);
  if (Stdlib_Option.isNone(params$1.after)) {
    QueryParamUtils.setIfExists(searchParams, "before", params$1.before, s => s);
  }
  if (!params$1.active) {
    QueryParamUtils.setIfExistsBool(searchParams, "active", params$1.active);
  }
  if (params$1.soldOrRented) {
    QueryParamUtils.setIfExistsBool(searchParams, "soldOrRented", params$1.soldOrRented);
  }
  if (params$1.underContract) {
    QueryParamUtils.setIfExistsBool(searchParams, "underContract", params$1.underContract);
  }
  if (params$1.withdrawnOrExpired) {
    QueryParamUtils.setIfExistsBool(searchParams, "withdrawnOrExpired", params$1.withdrawnOrExpired);
  }
  let str = searchParams.toString();
  if (str === "") {
    return "";
  } else {
    return "?" + str;
  }
}

function getCurrentParams() {
  return QueryParamUtils.URLHelpers.getCurrentParams(fromUrl, toParams);
}

function paramsToUrl(params) {
  let location = window.location;
  return location.pathname + toQueryString(params);
}

function setQueryParamsInURL(mode, params) {
  QueryParamUtils.URLHelpers.setQueryParamsInURL(paramsToUrl, toParams, fromUrl, mode, params);
}

function use() {
  return QueryParamUtils.URLHelpers.use(fromUrl, toParams, setQueryParamsInURL);
}

function preserveRelevantParamsWhenSwitchingModes(p) {
  return {
    rentalMode: p.rentalMode,
    sortOrder: p.sortOrder,
    areaIds: p.areaIds,
    maxBeds: p.maxBeds,
    minBeds: p.minBeds,
    keywords: p.keywords,
    offMlsOnly: p.offMlsOnly,
    includeNewDevelopments: false,
    active: p.active,
    withdrawnOrExpired: p.withdrawnOrExpired,
    underContract: p.underContract,
    soldOrRented: p.soldOrRented
  };
}

exports.getDefaultState = getDefaultState;
exports.clearDevelopmentFilters = clearDevelopmentFilters;
exports.normalizeDevelopmentParams = normalizeDevelopmentParams;
exports.ParamsFromURL = ParamsFromURL;
exports.Params = Params;
exports.toQueryString = toQueryString;
exports.getCurrentParams = getCurrentParams;
exports.paramsToUrl = paramsToUrl;
exports.setQueryParamsInURL = setQueryParamsInURL;
exports.use = use;
exports.preserveRelevantParamsWhenSwitchingModes = preserveRelevantParamsWhenSwitchingModes;
/* QueryParamUtils Not a pure module */
